import apiClient from './apiClient';

interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export interface NotificationPayload {
  userId?: string;
  userIds?: string[];
  title: string;
  body: string;
  image?: string;
  type?: 'system' | 'pet_inquiry' | 'chat' | 'follow' | 'post' | 'promotion' | 'admin' | 'custom' | 'warning' | 'policy_violation' | 'feature_update' | 'account_notice';
  category?: 'info' | 'warning' | 'success' | 'error' | 'promotional';
  priority?: 'low' | 'normal' | 'high' | 'critical';
  data?: any;
  actionUrl?: string;
  expiresAt?: string;
  targetFilters?: {
    platform?: string[];
    userTypes?: string[];
    locations?: string[];
    petCategories?: string[];
  };
}

export interface NotificationResult {
  total?: number;
  successful?: number;
  failed?: number;
  results?: any[];
  errors?: any[];
  notification?: any;
  deliveryStats?: any;
}

class NotificationService {
  async sendToUser(payload: NotificationPayload): Promise<NotificationResult> {
    const response = await apiClient.post<ApiResponse<NotificationResult>>('/notifications/admin/send-to-user', payload);
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to send notification');
    }
    return response.data.data;
  }

  async sendToMultipleUsers(payload: NotificationPayload): Promise<NotificationResult> {
    const response = await apiClient.post<ApiResponse<NotificationResult>>('/notifications/admin/send-to-multiple', payload);
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to send notifications');
    }
    return response.data.data;
  }

  async sendBroadcast(payload: NotificationPayload): Promise<NotificationResult> {
    const response = await apiClient.post<ApiResponse<NotificationResult>>('/notifications/admin/send-broadcast', payload);
    if (!response.data.success) {
      throw new Error(response.data.message || 'Failed to send broadcast');
    }
    return response.data.data;
  }
}

export default new NotificationService();

